export default __webpack_public_path__ + "static/media/entity-mention-span-create.7e69f499.gif";